import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReceiptBanner } from './components/ReceiptBanner/ReceiptBanner';
import { ReceiptBannerCaption } from './components/ReceiptBannerCaption/ReceiptBannerCaption';
import { ReceiptDetail } from './components/ReceiptDetail/ReceiptDetail';
import { ReceiptDetails } from './components/ReceiptDetails/ReceiptDetails';
import { ReceiptDivider } from './components/ReceiptDivider/ReceiptDivider';
import { ReceiptFooter } from './components/ReceiptFooter/ReceiptFooter';
import { ReceiptGroup } from './components/ReceiptGroup/ReceiptGroup';
import { ReceiptGroupTitle } from './components/ReceiptGroupTitle/ReceiptGroupTitle';
import { ReceiptHeader } from './components/ReceiptHeader/ReceiptHeader';
import { ReceiptHeaderImage } from './components/ReceiptHeaderImage/ReceiptHeaderImage';
import { ReceiptImage } from './components/ReceiptImage/ReceiptImage';
import { ReceiptInfoBlock } from './components/ReceiptInfoBlock/ReceiptInfoBlock';
import { ReceiptInfoText } from './components/ReceiptInfoText/ReceiptInfoText';
import { ReceiptLink } from './components/ReceiptLink/ReceiptLink';
import { ReceiptMain } from './components/ReceiptMain/ReceiptMain';
import { ReceiptModalToggle } from './components/ReceiptModalToggle/ReceiptModalToggle';
import { ReceiptRow } from './components/ReceiptRow/ReceiptRow';
import { ReceiptSpinner } from './components/ReceiptSpinner/ReceiptSpinner';
import { ReceiptStickyOnMobile } from './components/ReceiptStickyOnMobile/ReceiptStickyOnMobile';
import { ReceiptSubGroup } from './components/ReceiptSubGroup/ReceiptSubGroup';
import { ReceiptSubTotal } from './components/ReceiptSubTotal/ReceiptSubTotal';
import { ReceiptSupportText } from './components/ReceiptSupportText/ReceiptSupportText';
import { ReceiptTitle } from './components/ReceiptTitle/ReceiptTitle';
import { ReceiptTotal } from './components/ReceiptTotal/ReceiptTotal';
import { ReceiptTotalStrikedThrough } from './components/ReceiptTotalStrikedThrough/ReceiptTotalStrikedThrough';
import { ReceiptProvider } from './context/ReceiptContext';
import { StyledReceipt } from './styles/receipt.styled';
const Receipt = ({ isLoading, colorContext = 'on-light', children, dataTest = 'receipt', }) => {
    return (_jsx(StyledReceipt, { "$isLoading": isLoading, "data-test": dataTest, children: _jsxs(ReceiptProvider, { colorContext: colorContext, children: [children, isLoading && _jsx(ReceiptSpinner, { message: "Een ogenblik geduld, alstublieft" })] }) }));
};
Receipt.Banner = ReceiptBanner;
Receipt.BannerCaption = ReceiptBannerCaption;
Receipt.Detail = ReceiptDetail;
Receipt.Details = ReceiptDetails;
Receipt.Divider = ReceiptDivider;
Receipt.Footer = ReceiptFooter;
Receipt.Group = ReceiptGroup;
Receipt.GroupTitle = ReceiptGroupTitle;
Receipt.Header = ReceiptHeader;
Receipt.HeaderImage = ReceiptHeaderImage;
Receipt.Image = ReceiptImage;
Receipt.InfoBlock = ReceiptInfoBlock;
Receipt.InfoText = ReceiptInfoText;
Receipt.Link = ReceiptLink;
Receipt.Main = ReceiptMain;
Receipt.ModalToggle = ReceiptModalToggle;
Receipt.Row = ReceiptRow;
Receipt.StickyOnMobile = ReceiptStickyOnMobile;
Receipt.SubTotal = ReceiptSubTotal;
Receipt.SubGroup = ReceiptSubGroup;
Receipt.SupportText = ReceiptSupportText;
Receipt.Title = ReceiptTitle;
Receipt.Total = ReceiptTotal;
Receipt.TotalStrikedThrough = ReceiptTotalStrikedThrough;
export { Receipt };
